module.exports = __webpack_public_path__ + "fonts/DINPro-Cond.9b3413ea.otf";